import React from "react";
import { Link } from "react-router-dom";

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="min-h-screen bg-white transition-colors duration-200">
      <div className="container mx-auto px-6 py-12 max-w-4xl">
        <div className="mb-8 flex items-center justify-between">
          <Link
            to="/"
            className="flex items-center hover:opacity-90 transition-opacity"
          >
            <img
              src="/a.png"
              alt="Einstein AI"
              className="w-12 h-12 object-contain mr-3"
            />
            <span className="text-xl font-semibold text-gray-900">
              Einstein AI
            </span>
          </Link>
        </div>

        <div className="bg-white shadow-sm border border-gray-100 rounded-lg p-8">
          <h1 className="text-3xl font-bold mb-6 text-gray-900 text-center">
            Privacy Policy
          </h1>
          <p className="text-gray-600 mb-8 text-center italic">
            Effective Date: February 8, 2025
          </p>

          <div className="prose prose-lg max-w-none text-gray-700">
            <p>
              Einstein AI - Learn & Memorize (hereinafter referred to as the
              "App") is a Freemium app developed by Aydın Furkan Süren. This
              SERVICE is provided by Aydın Furkan Süren at no cost and is
              intended for use as is.
            </p>

            <p className="mt-4">
              This page is intended to inform users about policies regarding the
              collection, use, and disclosure of Personal Information for those
              who decide to use the Service.
            </p>

            <p className="mt-4">
              By choosing to use the service, you agree to the policies outlined
              in this Privacy Policy.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-3 text-gray-900">
              Information Collection and Use
            </h2>
            <p>
              The app collects certain user data for the functionality of its
              features, and for the sake of diagnostics. This includes device
              ID, device IP address, user's country, and navigation between
              screens data. This data is collected through Firebase but is not
              linked to your personal identity.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-3 text-gray-900">
              Log Data
            </h2>
            <p>
              The app collects log data of the app usage without linking user
              identity, only to diagnose crashes, errors and analyse the app
              performance.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-3 text-gray-900">
              Service Providers
            </h2>
            <p>
              No third-party companies or individuals are engaged to facilitate,
              provide, or analyze the service, as no data is collected from
              users.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-3 text-gray-900">
              Security
            </h2>
            <p>
              Your trust in providing personal information is valued, and
              commercially acceptable means are employed to protect it. However,
              while no method of transmission over the internet or electronic
              storage is 100% secure, absolute security cannot be guaranteed.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-3 text-gray-900">
              Links to Other Sites
            </h2>
            <p>
              The app may contain links to external websites or services.
              However, these sites are not operated or controlled by Aydın
              Furkan Süren, and therefore, no responsibility is assumed for
              their content, privacy policies, or practices.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-3 text-gray-900">
              Children's Privacy and Explicit Content Warning
            </h2>
            <p>
              The App does not contain external web access intended for users
              aged 18 and above, and does not knowingly collect any personally
              identifiable information from users under the age of 18.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-3 text-gray-900">
              Changes to This Privacy Policy
            </h2>
            <p>
              This Privacy Policy may be updated from time to time. Users will
              be notified of any changes by updating the "Effective Date" at the
              top of this policy.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-3 text-gray-900">
              Contact Support
            </h2>
            <p>
              For any questions, suggestions, or support regarding this app,
              please contact Aydın Furkan Süren at{" "}
              <a
                href="mailto:catyardapp@gmail.com"
                className="text-blue-600 hover:underline"
              >
                catyardapp@gmail.com
              </a>
              .
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
